import { SolarExamineReportApi } from '../apis';
import { handleData } from './response.handler';

export const SolarExamineReportService = {
  getExamineReportSummary,
  getExamineReport,
  getAllExamineReport,
  getAiAnalysisStatus,
  requestAIAnalysisJob,
  cancelAiAnalysisJob
};

function getExamineReportSummary(reportId) {
  return SolarExamineReportApi.getExamineReportSummary(reportId).then(handleData);
}
//getExaminereport
function getExamineReport(reportId) {
  return SolarExamineReportApi.getExamineReport(reportId).then(handleData);
}

//getExaminereport+aiAnalysisJob
function getAiAnalysisStatus(reportId, axiosConfig) {
  return SolarExamineReportApi.getAiAnalysisStatus(reportId, axiosConfig).then(handleData);
}

//getAllExaminereport
function getAllExamineReport() {
  return SolarExamineReportApi.getAllExamineReport().then(handleData);
}
//requestAiAnalysisJob
function requestAIAnalysisJob(
  reportId,
  jobKinds,
  altCorrectValue,
  isSampling = false,
  aiDetectImageRatio = null,
  heightSource = null,
  axiosConfig
) {
  return SolarExamineReportApi.requestAIAnalysisJob(
    reportId,
    jobKinds,
    altCorrectValue,
    isSampling,
    aiDetectImageRatio,
    heightSource,
    axiosConfig
  ).then(handleData);
}

//cancelAiAnalysisJob
function cancelAiAnalysisJob(aiJobId, axiosConfig) {
  return SolarExamineReportApi.cancelAiAnalysisJob(aiJobId, axiosConfig).then(handleData);
}
